import React from 'react';

const Footer = () => (
  <footer>
    <p className="footer-text">This is the footer</p>
  </footer>
);

export default Footer;
